import { BaseApiRequest } from "../baseApiRequest";
import { XcoreCore } from "XcoreCore";

/**
 * User token is still valid after logout in DEV mode.
 * This is not a bug because token is saved in httpOnly cookie which is being discarded only in case of built app
 */
export const logoutRequest = (core: XcoreCore): BaseApiRequest<Response> => core.fetch("/api/user/logout", { method: "POST" });
